import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createBranchWashMachineListApi } from 'features/branchManagement/api/washMachine';
import { BRANCH_WASH_MACHINE_LIST } from './useGetBranchWashMachineList';

export default function useCreateBranchWashMachine() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createBranchWashMachineListApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BRANCH_WASH_MACHINE_LIST] });
    },
  });
}
